import CustomizableProductSlate from './CustomizableProductSlate'

export default CustomizableProductSlate
